import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithAuthorization } from "../ApiMethod/ApiMethod";

export const GetDailyPujaDetailsBySlug = async (slug) => {
    const url = `${BaseUrl}/GetDailyPujaDetailsBySlug?Slug=${slug}`;
    const res = await getApiWithAuthorization(url);

    return res;
};